module.exports = __webpack_public_path__ + "img/apple-icon.d481d1a3.svg";